import { Button, Flex } from '@mantine/core';
import WestIcon from '@mui/icons-material/West';

export const PageFooter = ({
  hideBack,
  leftElement,
  leftOnClick,
  hideRight,
  buttonText,
  buttonIcon: rightIcon,
  disabled,
  loading,
  submitButton,
  rightOnClick,
}: {
  hideBack?: boolean;
  leftElement?: React.ReactNode;
  leftOnClick?: () => void;
  hideRight?: boolean;
  buttonText?: string;
  buttonIcon?: React.ReactNode;
  disabled?: boolean;
  loading?: boolean;
  submitButton?: boolean;
  rightOnClick?: () => void;
}) => {
  let justify = 'space-between';

  if (leftElement === undefined && hideBack) {
    justify = 'flex-end';
  }

  return (
    <Flex
      direction={'row'}
      justify={justify}
      style={{
        position: 'fixed',
        bottom: 'var(--mantine-spacing-md)',
        width: 'calc(100% - (var(--mantine-spacing-md) * 2))',
        maxWidth: 'calc(500px - (var(--mantine-spacing-md) * 2))',
      }}
    >
      {leftElement
        ? leftElement
        : !hideBack && (
            <Button variant={'back'} size="lg" onClick={leftOnClick}>
              <WestIcon htmlColor="var(--mantine-primary-color-filled)" />
            </Button>
          )}

      {!hideRight && (
        <Button
          rightSection={rightIcon}
          disabled={disabled}
          loading={loading}
          onClick={rightOnClick}
          type={submitButton ? 'submit' : 'button'}
        >
          {buttonText}
        </Button>
      )}
    </Flex>
  );
};
